import { Loader2 } from "lucide-react";

export function LoadingScreen({ message = "Loading…" }: { message?: string }) {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 text-vpm-forest-muted">
      <Loader2 className="h-8 w-8 animate-spin text-vpm-forest" />
      <p className="text-sm font-medium">{message}</p>
    </div>
  );
}

export function DashboardSkeleton() {
  return (
    <div className="page-container animate-fade-in">
      <div className="space-y-3">
        <div className="skeleton h-8 w-64" />
        <div className="skeleton h-4 w-96 max-w-full" />
      </div>
      <div className="grid gap-2.5 grid-cols-2 md:grid-cols-3 xl:grid-cols-6">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <div key={i} className="rounded-xl border border-vpm-border/70 bg-white px-3 py-2.5">
            <div className="flex items-center gap-2.5">
              <div className="skeleton h-7 w-7 shrink-0 rounded-lg" />
              <div className="min-w-0 flex-1 space-y-1.5">
                <div className="skeleton h-3 w-16" />
                <div className="skeleton h-5 w-8" />
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="grid gap-6 lg:grid-cols-2">
        <div className="card">
          <div className="skeleton mb-4 h-5 w-40" />
          <div className="skeleton h-64 w-full rounded-xl" />
        </div>
        <div className="card">
          <div className="skeleton mb-4 h-5 w-40" />
          <div className="skeleton h-64 w-full rounded-xl" />
        </div>
      </div>
    </div>
  );
}
